import InputMask from 'react-input-mask';
import {useField} from 'formik';
import React from 'react';

export const TimeMaskField = ({ error, value, placeholder, isDisabled, ...props})=> {
    const [, , help] = useField(props.name)
    const handleChange = (e)=> {
        props.onChange(e.target.value)
        help.setValue(e.target.value)
    }
    return (
        <label className={["auth-label", error ? 'error' : '', isDisabled ? 'is_disabled' : ''].join(' ')}>
            <InputMask
                mask="99:99"
                value={value}
                maskChar={null}
                readOnly={props.readOnly}
                onChange={handleChange}
                disabled={props.disabled}
                placeholder={'--:--'}
                onBlur={props.onBlur}
                name={props.name}
            >
                {({ name, placeholder }) => {
                    return (
                        <input
                            type="text"
                            disabled={props.disabled}
                            name={name}
                            inputMode="numeric"
                            className="auth-label-input"
                            placeholder={placeholder}
                        />
                    )
                }}
            </InputMask>
            <span className={['auth-label-placeholder', !!value?.length ? 'is_valid' : ''].join(' ')}>{placeholder}</span>
            <span className="authorization__error">
              {error}
            </span>
        </label>

    )
}
